import React from 'react'
import { useState } from 'react';

//*******************************Componentes PrimeReact************************************* */
import { TabView } from 'primereact/tabview';
import { TabPanel } from 'primereact/tabview';
import IngresosMantenimiento from './IngresosMantenimiento';
import IngresosBodegaEnc from './IngresosBodegaEnc'
import { ConfirmDialog } from 'primereact/confirmdialog';

const IngresosBodegaMaterialesScreen = () => {
    const [activeIndex, setActiveIndex] = useState(0);



    return (
        <div style={{ width: '99%' }}>
            <ConfirmDialog />
            <TabView className="col-12 homeTabView" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header='Encabezado'>
                    <IngresosBodegaEnc />
                </TabPanel>
                <TabPanel header='Detalles'>
                    <IngresosMantenimiento />
                </TabPanel>
            </TabView>

        </div>
    )
}

export default IngresosBodegaMaterialesScreen